export default "__VITE_ASSET__Be9rk0u7__"